var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    padding: 45px;\n    justify-content: center;\n    "], ["\n    display: flex;\n    padding: 45px;\n    justify-content: center;\n    "]);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/*
	6/13/2020 - Suhas
	
	This page shows the Rates section in the Landing page.
    
    The Rates section is separated in 3 parts as follows:
    1] RATES
        The Rates are fetched from the public URL of Pricing Engine
        The URL is fetched from "COMMON" set.

        The received response is read and shown in a format for:
        1. Conventional (15Yr Fixed and 30Yr Fixed)
        2. FHA (15Yr Fixed and 30Yr Fixed)
        3. VA (15Yr Fixed and 30Yr Fixed) - While fetching from the response, it will be USDA

        The APR is calculated based on the JSON file that we are using.

    2] Customize Quote
        This is a button below the Rates section.
        It will allows user to Cutomize the Rates shown in section 1, based on the user selection.
        
        On submission of the user selection, it will show the Rates table as in section 1 and replece section 1 rates.

        When the Customize Quote is selected, button will be hidden. Then Today's Rates button will be shown
        If clicked on Today's Rates and then clicked back on Customize Quote, then the slider should start from the beginning

    3] Apply Now
        This will redict to the ApplyNow with its lead id as c=lrtv.
        
        If the user has customized a quote, it add the customized options with ApplyNow link for POST.
        This will pre-select/prefill the ApplyNow when user is redirected.
	
*/
import React, { useState, useEffect } from "react";
import { Row, Col, Container, Button, Tabs, Tab, Modal } from "react-bootstrap";
import axios from 'axios';
import { format, parse, parseISO } from "date-fns";
import NumberFormat from 'react-number-format';
import PulseLoader from "react-spinners/PulseLoader";
import ScrollIntoView from 'react-scroll-into-view';
import { css } from "@emotion/core";
import '../css/rates.css';

import RatesSlider from '../components/rates';
import ThemeConfig from "./ThemeConfig";
import { ApplyNow } from "applynow";

import { UserSession } from 'usersession';
import { useDispatch } from "react-redux";
import { countryStateUpdate, stateCountyUpdate, stateListUpdate } from "../store/actions";
import PriceForStateConfig from "./PriceForState";
import { useStore } from "react-redux";

function Rates(props) {
    var _this = this;

    var locationError = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(error) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return getPrice(themeConfig.requestRates.leadSource);

                        case 2:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        return function locationError(_x) {
            return _ref.apply(this, arguments);
        };
    }();

    /** REACT-69: For Autism Heroes, this condition should work */


    var userSession = new UserSession();
    // const publicIp = require('public-ip');
    var themeConfig = new ThemeConfig(props);
    // const domain = themeConfig.domain;
    // let branchPropertyValue = themeConfig.requestRates.propertyValue;
    // const priceForStateConfig = new PriceForStateConfig(userSession.getPropertyState()); 

    var themeLeadSource = themeConfig.requestRates.leadSource;

    var domain = themeConfig.domain;
    var defaultPropertyCounty = themeConfig.requestRates.propertyCounty;

    var dispatch = useDispatch();

    var _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        noCCProgram = _useState2[0],
        setNoCCProgram = _useState2[1];

    var _useState3 = useState(true),
        _useState4 = _slicedToArray(_useState3, 2),
        showCvnRates = _useState4[0],
        setCvnRates = _useState4[1];

    var _useState5 = useState(false),
        _useState6 = _slicedToArray(_useState5, 2),
        showFHARates = _useState6[0],
        setFHARates = _useState6[1];

    var _useState7 = useState(false),
        _useState8 = _slicedToArray(_useState7, 2),
        showVARates = _useState8[0],
        setVARates = _useState8[1];

    var _useState9 = useState(false),
        _useState10 = _slicedToArray(_useState9, 2),
        showUsdaRates = _useState10[0],
        setUsdaRates = _useState10[1];

    var _useState11 = useState(true),
        _useState12 = _slicedToArray(_useState11, 2),
        show = _useState12[0],
        setShow = _useState12[1]; //  -----------> Currently hard coded to show the Rates section by default


    var _useState13 = useState(false),
        _useState14 = _slicedToArray(_useState13, 2),
        loading = _useState14[0],
        setLoading = _useState14[1];

    var _useState15 = useState(""),
        _useState16 = _slicedToArray(_useState15, 2),
        stateName = _useState16[0],
        setStateName = _useState16[1];

    var _useState17 = useState(false),
        _useState18 = _slicedToArray(_useState17, 2),
        productLoading = _useState18[0],
        setProductLoading = _useState18[1];

    var _useState19 = useState(false),
        _useState20 = _slicedToArray(_useState19, 2),
        convTab = _useState20[0],
        setConvTab = _useState20[1];

    var _useState21 = useState(false),
        _useState22 = _slicedToArray(_useState21, 2),
        fhaTab = _useState22[0],
        setFhaTab = _useState22[1];

    var _useState23 = useState(false),
        _useState24 = _slicedToArray(_useState23, 2),
        vaTab = _useState24[0],
        setVaTab = _useState24[1];

    var _useState25 = useState(false),
        _useState26 = _slicedToArray(_useState25, 2),
        usdaTab = _useState26[0],
        setUsdaTab = _useState26[1];

    var _useState27 = useState(false),
        _useState28 = _slicedToArray(_useState27, 2),
        showCHMModal = _useState28[0],
        setCHMModal = _useState28[1];

    var handleCHMClose = function handleCHMClose() {
        return setCHMModal(false);
    };

    /* States to set the received data from Pricing */

    var _useState29 = useState(themeConfig.requestRates.creditScore),
        _useState30 = _slicedToArray(_useState29, 2),
        defaultCreditScore = _useState30[0],
        setDefaultCreditScore = _useState30[1];

    var _useState31 = useState(themeConfig.requestRates.loanAmount),
        _useState32 = _slicedToArray(_useState31, 2),
        branchLoanAmount = _useState32[0],
        setBranchLoanAmount = _useState32[1];

    var _useState33 = useState(themeConfig.requestRates.propertyValue),
        _useState34 = _slicedToArray(_useState33, 2),
        branchPropertyValue = _useState34[0],
        setBranchPropertyValue = _useState34[1];

    var _useState35 = useState(""),
        _useState36 = _slicedToArray(_useState35, 2),
        conv15A = _useState36[0],
        setConv15A = _useState36[1];

    var _useState37 = useState(""),
        _useState38 = _slicedToArray(_useState37, 2),
        conv30A = _useState38[0],
        setConv30A = _useState38[1];

    var _useState39 = useState(""),
        _useState40 = _slicedToArray(_useState39, 2),
        fha15A = _useState40[0],
        setFha15A = _useState40[1];

    var _useState41 = useState(""),
        _useState42 = _slicedToArray(_useState41, 2),
        fha30A = _useState42[0],
        setFha30A = _useState42[1];

    var _useState43 = useState(""),
        _useState44 = _slicedToArray(_useState43, 2),
        va15A = _useState44[0],
        setVa15A = _useState44[1];

    var _useState45 = useState(""),
        _useState46 = _slicedToArray(_useState45, 2),
        va30A = _useState46[0],
        setVa30A = _useState46[1];

    var _useState47 = useState(""),
        _useState48 = _slicedToArray(_useState47, 2),
        usda15A = _useState48[0],
        setUsda15A = _useState48[1];

    var _useState49 = useState(""),
        _useState50 = _slicedToArray(_useState49, 2),
        usda30A = _useState50[0],
        setUsda30A = _useState50[1];

    var _useState51 = useState(""),
        _useState52 = _slicedToArray(_useState51, 2),
        fhaLimit = _useState52[0],
        setFhaLimit = _useState52[1];

    var _useState53 = useState(""),
        _useState54 = _slicedToArray(_useState53, 2),
        convLimit = _useState54[0],
        setConvLimit = _useState54[1];

    var _useState55 = useState(""),
        _useState56 = _slicedToArray(_useState55, 2),
        vaLimit = _useState56[0],
        setVaLimit = _useState56[1];

    var _useState57 = useState(""),
        _useState58 = _slicedToArray(_useState57, 2),
        usdaLimit = _useState58[0],
        setUSdaLimit = _useState58[1];

    var _useState59 = useState(""),
        _useState60 = _slicedToArray(_useState59, 2),
        productCreationTime = _useState60[0],
        setProductCreationTime = _useState60[1];

    /* End of States to set the received data from Pricing */

    var _useState61 = useState(true),
        _useState62 = _slicedToArray(_useState61, 2),
        customButton = _useState62[0],
        setCustomButton = _useState62[1]; //  State to toggle the view of Customize Quote button


    var _useState63 = useState(false),
        _useState64 = _slicedToArray(_useState63, 2),
        customRateQuote = _useState64[0],
        setCustomRateQuote = _useState64[1]; //  State for Customize Quote button to toggle Rates

    var todayDate = new Date(); //Today date
    var shortDate = new Intl.DateTimeFormat('en-US').format(todayDate);

    var override = css(_templateObject);

    var handleProdTabs = function handleProdTabs(key) {
        localStorage.setItem('checkedTab', key); // REACT-69

        if (key === 'conventional') {
            setCvnRates(true);
            setFHARates(false);
            setVARates(false);
            setUsdaRates(false);
            saveCVNDetails();
        } else if (key === 'fha') {
            setCvnRates(false);
            setFHARates(true);
            setVARates(false);
            setUsdaRates(false);
            saveFHADetails();
        } else if (key === 'va') {
            setCvnRates(false);
            setFHARates(false);
            setVARates(true);
            setUsdaRates(false);
            saveVADetails();
        } else if (key === 'usda') {
            setCvnRates(false);
            setFHARates(false);
            setVARates(false);
            setUsdaRates(true);
            saveUsdaDetails();
        }
    };

    function saveUsdaDetails() {
        if (usda15A.match === true) {
            saveSelectedProductDetails(usda15A);
        } else if (usda30A.match === true) {
            saveSelectedProductDetails(usda30A);
        }
    }

    function saveVADetails() {
        if (va15A.match === true) {
            saveSelectedProductDetails(va15A);
        } else if (va30A.match === true) {
            saveSelectedProductDetails(va30A);
        }
    }

    function saveFHADetails() {
        if (fha15A.match === true) {
            saveSelectedProductDetails(fha15A);
        } else if (fha30A.match === true) {
            saveSelectedProductDetails(fha30A);
        }
    }

    function saveCVNDetails() {
        if (conv15A.match === true) {
            saveSelectedProductDetails(conv15A);
        } else if (conv30A.match === true) {
            saveSelectedProductDetails(conv30A);
        }
    }

    function saveSelectedProductDetails(selectedProduct) {
        userSession.getSelectedProduct().setLoanType(selectedProduct.loanType);
    }

    var saveInitialRequestData = function saveInitialRequestData(requestedJson) {
        switch (requestedJson.loanPurpose) {
            case 0:
                userSession.setLoanPurpose("PURCHASE");
                break;
            case 1:
                userSession.setLoanPurpose("FULL DOCS REFI");
                break;
            case 2:
                userSession.setLoanPurpose("CASH OUT REFI");
                break;
            //no default
        }
        userSession.setLeadSource(requestedJson.leadSource);
        userSession.setPropertyState(requestedJson.propertyState);
        userSession.setPropertyZipCode(requestedJson.propertyZipCode);
        userSession.setBranchCode(requestedJson.branchCode);
        userSession.setPromoCode(requestedJson.promoCode);
        userSession.setPropertyType(requestedJson.propertyTypeKeyword);
    };

    var isAutismHeroes = props.promoCode && props.promoCode === 'ATH' ? true : false;

    /** No scrolling for FLW in customize quote */
    var isFLW = themeLeadSource === 'NET049' && themeConfig.requestRates.promoCode === 'FLW';
    localStorage.setItem('doNotScroll', isAutismHeroes || isFLW);

    // get default config data
    var getDefaultConfig = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(leadSource) {
            var theme_id, configData;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            theme_id = 'frontlinewarriors';

                            if (leadSource === 'BANKRATE.COM') theme_id = 'lowrates';
                            if (leadSource === 'TEXAS-TV') theme_id = 'lowrates-tv';
                            if (leadSource === 'CREDKARMA') theme_id = 'creditkarma';
                            if (leadSource === 'BLCHMWEB') theme_id = 'chm';

                            if (isAutismHeroes) theme_id = 'autismHeroes';
                            // if(
                            //     document.getElementsByClassName('taca_app') &&
                            //     document.getElementsByClassName('taca_app').length === 1
                            // ) theme_id = 'autism-heroes'; // REACT-69: please change if condition later
                            // Get the config data
                            _context2.next = 8;
                            return axios(process.env.REACT_APP_RATE_PRODUCT + "/" + theme_id + "-config.json");

                        case 8:
                            configData = _context2.sent;

                            setDefaultCreditScore(configData.data[0][theme_id].creditScore);
                            setBranchLoanAmount(configData.data[0][theme_id].loanAmount);
                            setBranchPropertyValue(configData.data[0][theme_id].propertyValue);
                            saveInitialRequestData(configData.data[0][theme_id]);

                        case 13:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        return function getDefaultConfig(_x2) {
            return _ref2.apply(this, arguments);
        };
    }();

    /**
     * @description Get the static data from s3.
     * @param leadSource leadsource of the website
     * @param userStateCode state code of the user
     */
    var getPrice = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(leadSource, userStateCode) {
            var theme_id, stateList, propertyStateData, response, county, zipcode, parseValue, dateTime;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            theme_id = 'frontlinewarriors';

                            if (leadSource === 'BANKRATE.COM') theme_id = 'lowrates';
                            if (leadSource === 'TEXAS-TV') theme_id = 'lowrates-tv';
                            if (leadSource === 'CREDKARMA') theme_id = 'creditkarma';
                            if (leadSource === 'BLCHMWEB') theme_id = 'chm';
                            if (isAutismHeroes) theme_id = 'autismHeroes';

                            // if(
                            //     document.getElementsByClassName('taca_app') &&
                            //     document.getElementsByClassName('taca_app').length === 1
                            // ) theme_id = 'autism-heroes'; // REACT-69: please change if condition later

                            _context3.prev = 6;
                            _context3.next = 9;
                            return axios(process.env.REACT_APP_RATE_PRODUCT + "/state.json");

                        case 9:
                            stateList = _context3.sent;

                            // Filter the state which has the county and zipcode
                            propertyStateData = stateList.data.find(function (d) {
                                return d.state.code === userStateCode;
                            });

                            // Get the static data from s3 for the filtered state else return the default data 

                            response = void 0;

                            if (!propertyStateData) {
                                _context3.next = 20;
                                break;
                            }

                            county = propertyStateData.state.county.code;
                            zipcode = propertyStateData.state.county.zipcode;
                            _context3.next = 17;
                            return axios(process.env.REACT_APP_RATE_PRODUCT + "/" + theme_id + "/" + userStateCode.toLowerCase() + "/" + county + "/" + zipcode + "/products.json");

                        case 17:
                            response = _context3.sent;
                            _context3.next = 23;
                            break;

                        case 20:
                            _context3.next = 22;
                            return axios(process.env.REACT_APP_RATE_PRODUCT + "/" + theme_id + "/default.json");

                        case 22:
                            response = _context3.sent;

                        case 23:
                            parseValue = parseISO(response.data.createdAt);
                            dateTime = format(parseValue, 'MM/dd/yyyy hh:mm a');

                            setProductCreationTime(dateTime);
                            userSession.setWebOffer(JSON.stringify(response.data));
                            if (response.data.CONV_30_YR_FIXED) {
                                setConv30A(response.data.CONV_30_YR_FIXED);
                            }

                            if (response.data.CONV_15_YR_FIXED) {
                                setConv15A(response.data.CONV_15_YR_FIXED);
                                setConvLimit(response.data.CONV_15_YR_FIXED.countyLimit);
                            }

                            if (response.data.FHA_15_YR_FIXED) {
                                setFha15A(response.data.FHA_15_YR_FIXED);
                            }

                            if (response.data.FHA_30_YR_FIXED) {
                                setFha30A(response.data.FHA_30_YR_FIXED);
                                setFhaLimit(response.data.FHA_30_YR_FIXED.countyLimit);
                            }

                            if (response.data.VA_30_YR_FIXED) {
                                setVa30A(response.data.VA_30_YR_FIXED);
                            }

                            if (response.data.VA_15_YR_FIXED) {
                                setVa15A(response.data.VA_15_YR_FIXED);
                                setVaLimit(response.data.VA_15_YR_FIXED.countyLimit);
                            }

                            if (response.data.USDA_15_YR_FIXED) {
                                setUsda15A(response.data.USDA_15_YR_FIXED);
                            }

                            if (response.data.USDA_30_YR_FIXED) {
                                setUsda30A(response.data.USDA_30_YR_FIXED);
                                setUSdaLimit(response.data.USDA_30_YR_FIXED.countyLimit);
                            }

                            setShow(true);
                            setProductLoading(false);
                            _context3.next = 43;
                            break;

                        case 39:
                            _context3.prev = 39;
                            _context3.t0 = _context3["catch"](6);

                            setProductLoading(false);
                            console.error('err price', _context3.t0);

                        case 43:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, _this, [[6, 39]]);
        }));

        return function getPrice(_x3, _x4) {
            return _ref3.apply(this, arguments);
        };
    }();

    useEffect(function () {
        if (!React.version.startsWith('17')) {
            console.error("RateQuotes requires react version 17.0.2 in order to avoid react hook error. The current version of react is " + React.version);
        }

        setShow(false);
        // Removing the loading because data rendered too fast no need of loader
        // setLoading(true);

        // Below get the default config data
        getDefaultConfig(themeLeadSource);

        // Below conditions are to determine with tab must be shown
        themeConfig.requestRates.scenarios.forEach(function (product) {
            if (product == "CONV_15_YR_FIXED" || product == "CONV_30_YR_FIXED") {
                setConvTab(true);
            }

            if (product == "FHA_15_YR_FIXED" || product == "FHA_30_YR_FIXED") {
                setFhaTab(true);
            }

            if (product == "VA_15_YR_FIXED" || product == "VA_30_YR_FIXED") {
                setVaTab(true);
            }

            if (product == "USDA_15_YR_FIXED" || product == "USDA_30_YR_FIXED") {
                setUsdaTab(true);
            }
        });

        // Get state from public endpoint

        var rechecked_domain = domain;

        if (isAutismHeroes) rechecked_domain = 'autismheroes.swmc.com';
        axios.post(process.env.REACT_APP_SUNSOFT_RESTSERVER_STATE_LIST, { "companyCode": "SUNWST000", "domain": rechecked_domain }, {
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            userSession.setStateList(JSON.stringify(response.data));
            dispatch(stateListUpdate(response.data));
        });

        /* Get client IP and geolocation(maxmind API) Task LRTV-3 */
        axios.get("https://api.ipify.org", { timeout: 2000 }).then(function (response) {
            var userIP = response.data;

            if (response.data) {
                axios.post(process.env.REACT_APP_MAXMIND, { "ip": userIP }, { timeout: 5000 }, {
                    headers: { 'Content-Type': 'application/json' }
                }).then(function (response) {
                    if (response.data !== "IP Not Available" && response.data !== "Invalid Country") {
                        var zipcode = response.data.zipcode;
                        if (zipcode) {
                            axios.get(process.env.REACT_APP_SUNSOFT_RESTSERVER_ZIPCODE + zipcode, {
                                headers: { 'Content-Type': 'application/json' }
                            }, { timeout: 15000 }).then(function () {
                                var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(response) {
                                    var priceForStateConfig, userReqData;
                                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                                        while (1) {
                                            switch (_context4.prev = _context4.next) {
                                                case 0:

                                                    userSession.setPropertyCounty(response.data.counties[0].code);
                                                    dispatch(stateCountyUpdate(response.data.counties[0].code));
                                                    userSession.setPropertyState(response.data.state);
                                                    dispatch(countryStateUpdate(response.data.state));

                                                    axios.get(process.env.REACT_APP_SUNSOFT_RESTSERVER_STATE + response.data.state, {
                                                        headers: { 'Content-Type': 'application/json' }
                                                    }).then(function (response) {
                                                        setStateName(response.data.stateName);
                                                    });

                                                    priceForStateConfig = new PriceForStateConfig(response.data.state);
                                                    userReqData = {
                                                        "branchCode": themeConfig.requestRates.branchCode,
                                                        "creditScore": themeConfig.requestRates.creditScore,
                                                        "loanAmount": themeConfig.requestRates.loanAmount,
                                                        "leadSource": themeConfig.requestRates.leadSource,
                                                        "loanPurpose": themeConfig.requestRates.loanPurpose,
                                                        "lockPeriod": themeConfig.requestRates.lockPeriod,
                                                        "matchExactPrice": themeConfig.requestRates.matchExactPrice,
                                                        "occupancy": themeConfig.requestRates.occupancy,
                                                        "price": themeConfig.requestRates.leadSource == "BANKRATE.COM" ? themeConfig.requestRates.price : priceForStateConfig.getPriceForState(),
                                                        "promoCode": themeConfig.requestRates.promoCode,
                                                        "propertyCounty": response.data.counties[0].code,
                                                        "propertyState": response.data.state,
                                                        "propertyZipCode": zipcode,
                                                        "propertyTypeKeyword": themeConfig.requestRates.propertyTypeKeyword,
                                                        "propertyValue": themeConfig.requestRates.propertyValue,
                                                        "userId": themeConfig.requestRates.userId,
                                                        "veteran": themeConfig.requestRates.veteran,
                                                        "scenarios": [themeConfig.requestRates.scenarios[0], themeConfig.requestRates.scenarios[1]]
                                                        // get the price scenario 
                                                    };
                                                    _context4.next = 9;
                                                    return getPrice(userReqData.leadSource, userReqData.propertyState);

                                                case 9:

                                                    saveInitialRequestData(userReqData);
                                                    userSession.setPropertyZipCode(zipcode);
                                                    return _context4.abrupt("return", userReqData);

                                                case 12:
                                                case "end":
                                                    return _context4.stop();
                                            }
                                        }
                                    }, _callee4, _this);
                                }));

                                return function (_x5) {
                                    return _ref4.apply(this, arguments);
                                };
                            }()).then(function () {
                                var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(userReqData) {
                                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                                        while (1) {
                                            switch (_context5.prev = _context5.next) {
                                                case 0:
                                                    setNoCCProgram(themeConfig.isNoCCProgram);

                                                case 1:
                                                case "end":
                                                    return _context5.stop();
                                            }
                                        }
                                    }, _callee5, _this);
                                }));

                                return function (_x6) {
                                    return _ref5.apply(this, arguments);
                                };
                            }()).catch(function (error) {
                                locationError();
                                console.log("zipcode Error", error);
                            });
                        } else {
                            locationError();
                        }
                    } else {
                        console.log(response.data); // Show Error message from lambda function
                        locationError();
                    }
                }).catch(function (error) {
                    console.log(error);
                    locationError(error);
                });
            }
        }).catch(function (error) {
            locationError();
            console.log(error);
        });

        userSession.setCustomQuote(customRateQuote);
        saveCVNDetails();
    }, []);

    return React.createElement(
        "div",
        null,
        themeLeadSource !== "BLCHMWEB" ? React.createElement(
            Container,
            { className: "text-center shadow-sm d-flex justify-content-center rate-title-bg-color", fluid: true },
            React.createElement(
                Row,
                null,
                React.createElement(
                    Col,
                    { className: "py-1", id: "todayRatesTitle" },
                    customRateQuote ? React.createElement(
                        "h1",
                        { className: "text-white" },
                        "YOUR CUSTOM QUOTE"
                    ) : React.createElement(
                        "h1",
                        { className: "text-white" },
                        "TODAY'S RATES ",
                        stateName ? "FOR " + stateName.toUpperCase() : null
                    )
                )
            )
        ) : null,
        React.createElement(
            Container,
            { className: "ratesSection" },
            React.createElement(
                "div",
                { className: !show ? "d-none" : null },
                React.createElement(
                    Tabs,
                    { className: "justify-content-center pt-1", defaultActiveKey: "conventional", id: "home-products-tabs", onSelect: function onSelect(k) {
                            return handleProdTabs(k);
                        } },
                    convTab === true ? React.createElement(
                        Tab,
                        { as: Row, className: showCvnRates ? "d-flex justify-content-center convRates conv-wrapper" : "d-none convRates conv-wrapper", eventKey: "conventional", title: "Conventional" },
                        props.offertext !== "" && !productLoading && (conv15A.match || conv30A.match) ? React.createElement(
                            Col,
                            { className: "d-block", lg: 12 },
                            React.createElement(
                                "h4",
                                { className: "text-center w-auto textBlue poppins-med py-2 mb-0" },
                                React.createElement(
                                    "strong",
                                    null,
                                    props.offertext
                                )
                            )
                        ) : null,
                        React.createElement(
                            Col,
                            { className: "" + (conv15A.rate == conv15A.apr || conv30A.rate == conv30A.apr && noCCProgram === true ? "d-block" : "d-none"), lg: 12 },
                            React.createElement(
                                "h4",
                                { className: "text-center noClosingCost w-auto textBlue poppins-med py-2 mb-0" },
                                React.createElement(
                                    "strong",
                                    null,
                                    "No Closing Costs!"
                                )
                            )
                        ),
                        conv15A.match === true ? React.createElement(
                            Col,
                            { lg: conv15A.rate == conv15A.apr || noCCProgram === true || conv15A.apr - conv15A.rate <= .05 ? 3 : 5, className: "textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3" },
                            React.createElement(
                                ApplyNow,
                                { id: "appNow_conv15A", leadSource: themeLeadSource, data: conv15A },
                                React.createElement(
                                    "h4",
                                    { className: "textBlue poppins-bold" },
                                    "15 YR FIXED"
                                ),
                                conv15A.rate == conv15A.apr || noCCProgram === true || conv15A.apr - conv15A.rate <= .05 ? React.createElement(
                                    "h2",
                                    { className: "reducefontSize" },
                                    React.createElement(
                                        "strong",
                                        null,
                                        React.createElement(NumberFormat, { value: conv15A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                    )
                                ) : React.createElement(
                                    "div",
                                    null,
                                    React.createElement(
                                        "h2",
                                        { className: "reducefontSize" },
                                        React.createElement(
                                            "strong",
                                            null,
                                            React.createElement(NumberFormat, { value: conv15A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true }),
                                            " / ",
                                            React.createElement(NumberFormat, { value: conv15A.apr, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                        )
                                    )
                                ),
                                React.createElement(
                                    "h4",
                                    { className: "fontSizeRateAprText textBlue poppins-med" },
                                    "(Rate ",
                                    conv15A.rate == conv15A.apr || noCCProgram === true || conv15A.rate - conv15A.apr <= .05 ? "&" : "/",
                                    " APR)"
                                ),
                                themeLeadSource !== "BLCHMWEB" ? React.createElement(
                                    "h3",
                                    { className: "lbl-Apply" },
                                    React.createElement(
                                        "strong",
                                        null,
                                        themeLeadSource == "BANKRATE.COM" ? "Get Quote" : "Apply Now"
                                    )
                                ) : null
                            )
                        ) : null,
                        conv30A.match === true ? React.createElement(
                            Col,
                            { lg: conv30A.rate == conv30A.apr || noCCProgram === true || conv30A.apr - conv30A.rate <= .05 ? 3 : 5, className: "textBlue poppins-black text-center pt-3" },
                            React.createElement(
                                ApplyNow,
                                { id: "appNow_conv30A", leadSource: themeLeadSource, data: conv30A },
                                React.createElement(
                                    "h4",
                                    { className: "textBlue poppins-bold" },
                                    "30 YR FIXED"
                                ),
                                conv30A.rate == conv30A.apr || noCCProgram === true || conv30A.apr - conv30A.rate <= .05 ? React.createElement(
                                    "h2",
                                    { className: "reducefontSize" },
                                    React.createElement(
                                        "strong",
                                        null,
                                        React.createElement(NumberFormat, { value: conv30A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                    )
                                ) : React.createElement(
                                    "div",
                                    null,
                                    React.createElement(
                                        "h2",
                                        { className: "reducefontSize" },
                                        React.createElement(
                                            "strong",
                                            null,
                                            React.createElement(NumberFormat, { value: conv30A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true }),
                                            " / ",
                                            React.createElement(NumberFormat, { value: conv30A.apr, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                        )
                                    )
                                ),
                                React.createElement(
                                    "h4",
                                    { className: "fontSizeRateAprText textBlue poppins-med" },
                                    "(Rate ",
                                    conv30A.rate == conv30A.apr || noCCProgram === true || conv30A.rate - conv30A.apr <= .05 ? "&" : "/",
                                    " APR)"
                                ),
                                themeLeadSource !== "BLCHMWEB" ? React.createElement(
                                    "h3",
                                    { className: "lbl-Apply" },
                                    React.createElement(
                                        "strong",
                                        null,
                                        themeLeadSource == "BANKRATE.COM" ? "Get Quote" : "Apply Now"
                                    )
                                ) : null
                            )
                        ) : null
                    ) : null,
                    fhaTab === true ? React.createElement(
                        Tab,
                        { as: Row, className: showFHARates ? "d-flex justify-content-center fhaRates" : "d-none fhaRates", eventKey: "fha", title: "FHA" },
                        props.offertext !== "" && !productLoading && (fha15A.match || fha30A.match) ? React.createElement(
                            Col,
                            { className: "d-block", lg: 12 },
                            React.createElement(
                                "h4",
                                { className: "text-center w-auto textBlue poppins-med py-2 mb-0" },
                                React.createElement(
                                    "strong",
                                    null,
                                    props.offertext
                                )
                            )
                        ) : null,
                        fha15A ? !fha15A.match : null && fha30A ? !fha30A.match : null ? React.createElement(
                            "h4",
                            null,
                            "We are unable to display any products at this time."
                        ) : null,
                        fha15A.match === true ? React.createElement(
                            Col,
                            { lg: fha15A.rate === fha15A.apr || fha15A.apr == 0 || fha15A.apr - fha15A.rate <= .05 ? 3 : 5, className: "textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3" },
                            React.createElement(
                                ApplyNow,
                                { id: "appNow_fha15A", leadSource: themeLeadSource, data: fha15A },
                                React.createElement(
                                    "h4",
                                    { className: "textBlue poppins-bold" },
                                    "15 YR FIXED"
                                ),
                                fha15A.rate === fha15A.apr || fha15A.apr == 0 || fha15A.apr - fha15A.rate <= .05 ? React.createElement(
                                    "h2",
                                    { className: "reducefontSize" },
                                    React.createElement(
                                        "strong",
                                        null,
                                        React.createElement(NumberFormat, { value: fha15A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                    )
                                ) : React.createElement(
                                    "div",
                                    null,
                                    React.createElement(
                                        "h2",
                                        { className: "reducefontSize" },
                                        React.createElement(
                                            "strong",
                                            null,
                                            React.createElement(NumberFormat, { value: fha15A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true }),
                                            " / ",
                                            React.createElement(NumberFormat, { value: fha15A.apr, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                        )
                                    )
                                ),
                                React.createElement(
                                    "h4",
                                    { className: "fontSizeRateAprText textBlue poppins-med", style: { fontSize: "1rem" } },
                                    "(Rate ",
                                    fha15A.rate === fha15A.apr || fha15A.apr == 0 || fha15A.apr - fha15A.rate <= .05 ? "&" : "/",
                                    " APR)"
                                ),
                                themeLeadSource !== "BLCHMWEB" ? React.createElement(
                                    "h3",
                                    { className: "lbl-Apply" },
                                    React.createElement(
                                        "strong",
                                        null,
                                        themeLeadSource == "BANKRATE.COM" ? "Get Quote" : "Apply Now"
                                    )
                                ) : null
                            )
                        ) : null,
                        fha30A.match === true ? React.createElement(
                            Col,
                            { lg: fha30A.rate === fha30A.apr || fha30A.apr == 0 || fha30A.apr - fha30A.rate <= .05 ? 3 : 5, className: "textBlue poppins-black text-center pt-3" },
                            React.createElement(
                                ApplyNow,
                                { id: "appNow_fha30A", leadSource: themeLeadSource, data: fha30A },
                                React.createElement(
                                    "h4",
                                    { className: "textBlue poppins-bold" },
                                    "30 YR FIXED"
                                ),
                                fha30A.rate === fha30A.apr || fha30A.apr == 0 || fha30A.apr - fha30A.rate <= .05 ? React.createElement(
                                    "h2",
                                    { className: "reducefontSize" },
                                    React.createElement(
                                        "strong",
                                        null,
                                        React.createElement(NumberFormat, { value: fha30A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                    )
                                ) : React.createElement(
                                    "div",
                                    null,
                                    React.createElement(
                                        "h2",
                                        { className: "reducefontSize" },
                                        React.createElement(
                                            "strong",
                                            null,
                                            React.createElement(NumberFormat, { value: fha30A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true }),
                                            " / ",
                                            React.createElement(NumberFormat, { value: fha30A.apr, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                        )
                                    )
                                ),
                                React.createElement(
                                    "h4",
                                    { className: "fontSizeRateAprText textBlue poppins-med", style: { fontSize: "1rem" } },
                                    "(Rate ",
                                    fha30A.rate === fha30A.apr || fha30A.apr == 0 || fha30A.apr - fha30A.rate <= .05 ? "&" : "/",
                                    " APR)"
                                ),
                                themeLeadSource !== "BLCHMWEB" ? React.createElement(
                                    "h3",
                                    { className: "lbl-Apply" },
                                    React.createElement(
                                        "strong",
                                        null,
                                        themeLeadSource == "BANKRATE.COM" ? "Get Quote" : "Apply Now"
                                    )
                                ) : null
                            )
                        ) : null
                    ) : null,
                    vaTab === true ? React.createElement(
                        Tab,
                        { as: Row, className: showVARates ? "d-flex justify-content-center convRates" : "d-none convRates", eventKey: "va", title: "VA" },
                        props.offertext !== "" && !productLoading && (va15A.match || va30A.match) ? React.createElement(
                            Col,
                            { className: "d-block", lg: 12 },
                            React.createElement(
                                "h4",
                                { className: "text-center w-auto textBlue poppins-med py-2 mb-0" },
                                React.createElement(
                                    "strong",
                                    null,
                                    props.offertext
                                )
                            )
                        ) : null,
                        va15A ? !va15A.match : null && va30A ? !va30A.match : null ? React.createElement(
                            "h4",
                            null,
                            "We are unable to display any products at this time."
                        ) : null,
                        themeLeadSource !== "BLCHMWEB" && va15A.match === true ? React.createElement(
                            Col,
                            { lg: va15A.rate === va15A.apr || va15A.apr == 0 || va15A.apr - va15A.rate <= .05 ? 3 : 5, className: "textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3" },
                            React.createElement(
                                ApplyNow,
                                { id: "appNow_va15A", leadSource: themeLeadSource, data: va15A },
                                React.createElement(
                                    "h4",
                                    { className: "textBlue poppins-bold" },
                                    "15 YR FIXED"
                                ),
                                va15A.rate === va15A.apr || va15A.apr == 0 || va15A.apr - va15A.rate <= .05 ? React.createElement(
                                    "h2",
                                    { className: "reducefontSize" },
                                    React.createElement(
                                        "strong",
                                        null,
                                        React.createElement(NumberFormat, { value: va15A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                    )
                                ) : React.createElement(
                                    "div",
                                    null,
                                    React.createElement(
                                        "h2",
                                        { className: "reducefontSize" },
                                        React.createElement(
                                            "strong",
                                            null,
                                            React.createElement(NumberFormat, { value: va15A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true }),
                                            " / ",
                                            React.createElement(NumberFormat, { value: va15A.apr, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                        )
                                    )
                                ),
                                React.createElement(
                                    "h4",
                                    { className: "textBlue poppins-med pt-0", style: { fontSize: "1rem" } },
                                    "(Rate ",
                                    va15A.rate === va15A.apr || va15A.apr == 0 || va15A.apr - va15A.rate <= .05 ? "&" : "/",
                                    " APR)"
                                ),
                                themeLeadSource !== "BLCHMWEB" ? React.createElement(
                                    "h3",
                                    { className: "lbl-Apply" },
                                    React.createElement(
                                        "strong",
                                        null,
                                        themeLeadSource == "BANKRATE.COM" ? "Get Quote" : "Apply Now"
                                    )
                                ) : null
                            )
                        ) : null,
                        va30A.match === true ? React.createElement(
                            Col,
                            { lg: va30A.rate === va30A.apr || va30A.apr == 0 || va30A.apr - va30A.rate <= .05 ? 3 : 5, className: "textBlue poppins-black text-center pt-3" },
                            React.createElement(
                                ApplyNow,
                                { id: "appNow_va30A", leadSource: themeLeadSource, data: va30A },
                                React.createElement(
                                    "h4",
                                    { className: "textBlue poppins-bold" },
                                    "30 YR FIXED"
                                ),
                                va30A.rate === va30A.apr || va30A.apr == 0 || va30A.apr - va30A.rate <= .05 ? React.createElement(
                                    "h2",
                                    { className: "reducefontSize" },
                                    React.createElement(
                                        "strong",
                                        null,
                                        React.createElement(NumberFormat, { value: va30A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                    )
                                ) : React.createElement(
                                    "div",
                                    null,
                                    React.createElement(
                                        "h2",
                                        { className: "reducefontSize" },
                                        React.createElement(
                                            "strong",
                                            null,
                                            React.createElement(NumberFormat, { value: va30A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true }),
                                            " / ",
                                            React.createElement(NumberFormat, { value: va30A.apr, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                        )
                                    )
                                ),
                                React.createElement(
                                    "h4",
                                    { className: "textBlue poppins-med pt-0", style: { fontSize: "1rem" } },
                                    "(Rate ",
                                    va30A.rate === va30A.apr || va30A.apr == 0 || va30A.apr - va30A.rate <= .05 ? "&" : "/",
                                    " APR)"
                                ),
                                themeLeadSource !== "BLCHMWEB" ? React.createElement(
                                    "h3",
                                    { className: "lbl-Apply" },
                                    React.createElement(
                                        "strong",
                                        null,
                                        themeLeadSource == "BANKRATE.COM" ? "Get Quote" : "Apply Now"
                                    )
                                ) : null
                            )
                        ) : null
                    ) : null,
                    usdaTab === true && themeLeadSource !== "TEXAS-TV" && themeLeadSource !== "BANKRATE.COM" ? React.createElement(
                        Tab,
                        { as: Row, className: showUsdaRates ? "d-flex justify-content-center convRates" : "d-none convRates", eventKey: "usda", title: "USDA" },
                        props.offertext !== "" && !productLoading && (usda15A.match || usda30A.match) ? React.createElement(
                            Col,
                            { className: "d-block", lg: 12 },
                            React.createElement(
                                "h4",
                                { className: "text-center w-auto textBlue poppins-med py-2 mb-0" },
                                React.createElement(
                                    "strong",
                                    null,
                                    props.offertext
                                )
                            )
                        ) : null,
                        usda15A ? !usda15A.match : null && usda30A ? !usda30A.match : null ? React.createElement(
                            "h4",
                            null,
                            "We are unable to display any products at this time."
                        ) : null,
                        themeLeadSource !== "BLCHMWEB" && usda15A.match === true ? React.createElement(
                            Col,
                            { lg: usda15A.rate === usda15A.apr || usda15A.apr == 0 || usda15A.apr - usda15A.rate <= .05 ? 3 : 5, className: "textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3" },
                            React.createElement(
                                ApplyNow,
                                { id: "appNow_usda15A", leadSource: themeLeadSource, data: usda15A },
                                React.createElement(
                                    "h4",
                                    { className: "textBlue poppins-bold" },
                                    "15 YR FIXED"
                                ),
                                usda15A.rate === usda15A.apr || usda15A.apr == 0 || usda15A.apr - usda15A.rate <= .05 ? React.createElement(
                                    "h2",
                                    { className: "reducefontSize" },
                                    React.createElement(
                                        "strong",
                                        null,
                                        React.createElement(NumberFormat, { value: usda15A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                    )
                                ) : React.createElement(
                                    "div",
                                    null,
                                    React.createElement(
                                        "h2",
                                        { className: "reducefontSize" },
                                        React.createElement(
                                            "strong",
                                            null,
                                            React.createElement(NumberFormat, { value: usda15A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true }),
                                            " / ",
                                            React.createElement(NumberFormat, { value: usda15A.apr, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                        )
                                    )
                                ),
                                React.createElement(
                                    "h4",
                                    { className: "fontSizeRateAprText textBlue poppins-med pt-0", style: { fontSize: "1rem" } },
                                    "(Rate ",
                                    usda15A.rate === usda15A.apr || usda15A.apr == 0 || usda15A.apr - usda15A.rate <= .05 ? "&" : "/",
                                    " APR)"
                                ),
                                themeLeadSource !== "BLCHMWEB" ? React.createElement(
                                    "h3",
                                    { className: "lbl-Apply" },
                                    React.createElement(
                                        "strong",
                                        null,
                                        themeLeadSource == "BANKRATE.COM" ? "Get Quote" : "Apply Now"
                                    )
                                ) : null
                            )
                        ) : null,
                        usda30A.match === true ? React.createElement(
                            Col,
                            { lg: usda30A.rate === usda30A.apr || usda30A.apr == 0 || usda30A.apr - usda30A.rate <= .05 ? 3 : 5, className: "textBlue poppins-black text-center pt-3" },
                            React.createElement(
                                ApplyNow,
                                { id: "appNow_usda30A", leadSource: themeLeadSource, data: usda30A },
                                React.createElement(
                                    "h4",
                                    { className: "textBlue poppins-bold" },
                                    "30 YR FIXED"
                                ),
                                usda30A.rate === usda30A.apr || usda30A.apr == 0 || usda30A.apr - usda30A.rate <= .05 ? React.createElement(
                                    "h2",
                                    { className: "reducefontSize" },
                                    React.createElement(
                                        "strong",
                                        null,
                                        React.createElement(NumberFormat, { value: usda30A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                    )
                                ) : React.createElement(
                                    "div",
                                    null,
                                    React.createElement(
                                        "h2",
                                        { className: "reducefontSize" },
                                        React.createElement(
                                            "strong",
                                            null,
                                            React.createElement(NumberFormat, { value: usda30A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true }),
                                            " / ",
                                            React.createElement(NumberFormat, { value: usda30A.apr, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                        )
                                    )
                                ),
                                React.createElement(
                                    "h4",
                                    { className: "fontSizeRateAprText textBlue poppins-med pt-0", style: { fontSize: "1rem" } },
                                    "(Rate ",
                                    usda30A.rate === usda30A.apr || usda30A.apr == 0 || usda30A.apr - usda30A.rate <= .05 ? "&" : "/",
                                    " APR)"
                                ),
                                themeLeadSource !== "BLCHMWEB" ? React.createElement(
                                    "h3",
                                    { className: "lbl-Apply" },
                                    React.createElement(
                                        "strong",
                                        null,
                                        themeLeadSource == "BANKRATE.COM" ? "Get Quote" : "Apply Now"
                                    )
                                ) : null
                            )
                        ) : null
                    ) : null
                )
            )
        ),
        React.createElement(
            Container,
            null,
            customRateQuote ? React.createElement(RatesSlider, { leadSource: themeLeadSource, phoneNumber: props.phoneNumber, phoneText: props.phoneText }) : ""
        ),
        themeLeadSource !== "BLCHMWEB" ? React.createElement(
            Container,
            { className: !show ? "d-none" : null },
            React.createElement(
                Row,
                { className: "textBlue poppins-med d-flex justify-content-center" },
                React.createElement(
                    Col,
                    { lg: 12 },
                    React.createElement("hr", null)
                ),
                React.createElement(
                    Col,
                    { md: "6" },
                    customButton ? React.createElement(
                        ScrollIntoView,
                        { smooth: true, selector: "#todayRatesTitle" },
                        React.createElement(
                            Button,
                            { className: "cyanButton my-0", onClick: function onClick() {
                                    setCustomButton(false);setCustomRateQuote(true);setShow(false);
                                } },
                            "Customize Quote"
                        )
                    ) : null
                )
            )
        ) : null,
        React.createElement(
            Container,
            { className: "text-center text-white mainBody " + (!loading ? null : "d-none"), fluid: true },
            customButton ? React.createElement(
                Row,
                { className: "d-flex justify-content-center" },
                !themeLeadSource == "BLCHMWEB" ? React.createElement(
                    Col,
                    { xs: "10", md: "8", className: "pt-2 mt-2 ratesTitle text-center mainBody", style: {
                            color: "rgb(14, 62, 155)" } },
                    React.createElement(
                        "h6",
                        { className: showCvnRates && !loading ? "mb-0" : " d-none" },
                        "Refinance ",
                        themeLeadSource == "NET049" || themeLeadSource == "INBOUNDNONPC" ? "| No Subordinate Financing " : null,
                        "| ",
                        defaultCreditScore,
                        " FICO"
                    ),
                    showCvnRates && !loading ? React.createElement(
                        "h6",
                        null,
                        "The rates above are based on a loan amount of ",
                        React.createElement(NumberFormat, { value: branchLoanAmount, displayType: 'text', thousandSeparator: true, prefix: '$', decimalScale: 0, fixedDecimalScale: false }),
                        " with an appraised value of ",
                        React.createElement(NumberFormat, { value: branchPropertyValue, displayType: 'text', thousandSeparator: true, prefix: '$', decimalScale: 0, fixedDecimalScale: false }),
                        ".",
                        React.createElement("br", null),
                        "Loans that do not meet these criteria may have a higher interest rate and Annual Percentage Rate (APR). ",
                        convLimit ? " Maximum loan amount may vary for your county." : null,
                        React.createElement("br", null),
                        "Rates are subject to change without notice. Not all applicants will qualify. Interest Rate and APR as of\xA0",
                        productCreationTime,
                        "."
                    ) : null,
                    React.createElement(
                        "h6",
                        { className: showFHARates && !loading && (fha15A.match === true || fha30A.match === true) ? "mb-0" : " d-none" },
                        "Refinance ",
                        themeLeadSource == "NET049" || themeLeadSource == "INBOUNDNONPC" ? "| No Subordinate Financing " : null,
                        "| ",
                        defaultCreditScore,
                        " FICO"
                    ),
                    showFHARates && !loading && (fha15A.match === true || fha30A.match === true) ? React.createElement(
                        "h6",
                        null,
                        "The rates above are based on a loan amount of ",
                        React.createElement(NumberFormat, { value: branchLoanAmount, displayType: 'text', thousandSeparator: true, prefix: '$', decimalScale: 0, fixedDecimalScale: false }),
                        " with an appraised value of ",
                        React.createElement(NumberFormat, { value: branchPropertyValue, displayType: 'text', thousandSeparator: true, prefix: '$', decimalScale: 0, fixedDecimalScale: false }),
                        ".",
                        React.createElement("br", null),
                        "Loans that do not meet these criteria may have a higher interest rate and Annual Percentage Rate (APR). ",
                        fhaLimit ? " Maximum loan amount may vary for your county." : null,
                        React.createElement("br", null),
                        "Rates are subject to change without notice. Not all applicants will qualify. Interest Rate and APR as of\xA0",
                        productCreationTime,
                        "."
                    ) : null,
                    React.createElement(
                        "h6",
                        { className: showVARates && !loading && (va15A.match === true || va30A.match === true) ? "mb-0" : " d-none" },
                        "Refinance ",
                        themeLeadSource == "NET049" || themeLeadSource == "INBOUNDNONPC" ? "| No Subordinate Financing " : null,
                        "| ",
                        defaultCreditScore,
                        " FICO"
                    ),
                    showVARates && !loading && (va15A.match === true || va30A.match === true) ? React.createElement(
                        "h6",
                        null,
                        "The rates above are based on a loan amount of ",
                        React.createElement(NumberFormat, { value: branchLoanAmount, displayType: 'text', thousandSeparator: true, prefix: '$', decimalScale: 0, fixedDecimalScale: false }),
                        " with an appraised value of ",
                        React.createElement(NumberFormat, { value: branchPropertyValue, displayType: 'text', thousandSeparator: true, prefix: '$', decimalScale: 0, fixedDecimalScale: false }),
                        ".",
                        React.createElement("br", null),
                        "Loans that do not meet these criteria may have a higher interest rate and Annual Percentage Rate (APR). ",
                        vaLimit ? " Maximum loan amount may vary for your county." : null,
                        React.createElement("br", null),
                        "Rates are subject to change without notice. Not all applicants will qualify. Interest Rate and APR as of\xA0",
                        productCreationTime,
                        "."
                    ) : null,
                    React.createElement(
                        "h6",
                        { className: showUsdaRates && !loading && (usda15A.match === true || usda30A.match === true) ? "mb-0" : " d-none" },
                        "Refinance ",
                        themeLeadSource == "NET049" || themeLeadSource == "INBOUNDNONPC" ? "| No Subordinate Financing " : null,
                        "| ",
                        defaultCreditScore,
                        " FICO"
                    ),
                    showUsdaRates && !loading && (usda15A.match === true || usda30A.match === true) ? React.createElement(
                        "h6",
                        null,
                        "The rates above are based on a loan amount of ",
                        React.createElement(NumberFormat, { value: branchLoanAmount, displayType: 'text', thousandSeparator: true, prefix: '$', decimalScale: 0, fixedDecimalScale: false }),
                        " with an appraised value of ",
                        React.createElement(NumberFormat, { value: branchPropertyValue, displayType: 'text', thousandSeparator: true, prefix: '$', decimalScale: 0, fixedDecimalScale: false }),
                        ".",
                        React.createElement("br", null),
                        "Loans that do not meet these criteria may have a higher interest rate and Annual Percentage Rate (APR). ",
                        usdaLimit ? " Maximum loan amount may vary for your county." : null,
                        React.createElement("br", null),
                        "Rates are subject to change without notice. Not all applicants will qualify. Interest Rate and APR as of\xA0",
                        productCreationTime,
                        "."
                    ) : null,
                    themeLeadSource == "NET049" || themeLeadSource == "INBOUNDNONPC" ? React.createElement(
                        "h6",
                        null,
                        document.getElementsByClassName("taca_app") && document.getElementsByClassName("taca_app").length === 1 ? "This Lender Credit is an exclusive offer to the members of TACA that register through this site. The Lender Credit shall be applied at the time of closing and cannot exceed the actual amount of the eligible fees and program guidelines. This offer is non-transferable and cannot be combined with any other offer." : "This Lender Credit is an exclusive offer to doctors, nurses, law enforcement officers, firefighters, Emergency Medical Technicians (EMT) and US military personnel that register through this site. The Lender Credit shall be applied at the time of closing and cannot exceed the actual amount of the eligible fees and program guidelines. This offer is non-transferable and cannot be combined with any other offer."
                    ) : null
                ) : !loading ? React.createElement(
                    Col,
                    { className: "pt-2 mt-2 ratesTitle text-center mainBody" },
                    React.createElement(
                        "h6",
                        null,
                        "Rates as of ",
                        productCreationTime,
                        ". *",
                        React.createElement(
                            "a",
                            { href: "#", onClick: function onClick() {
                                    return setCHMModal(!showCHMModal);
                                } },
                            "Rate Assumptions"
                        )
                    )
                ) : null
            ) : null
        ),
        React.createElement(
            Modal,
            {
                id: "chmModal",
                centered: true,
                show: showCHMModal,
                onHide: handleCHMClose
            },
            React.createElement(
                Modal.Header,
                { closeButton: true },
                React.createElement(
                    "h4",
                    { className: "text-white" },
                    "Mortgage Rate Assumptions"
                )
            ),
            React.createElement(
                Modal.Body,
                null,
                React.createElement(
                    "p",
                    null,
                    "* Rates shown assume a purchase transaction."
                ),
                React.createElement(
                    "p",
                    null,
                    "* Annual Percentage Rate (APR) calculations assume a purchase transaction of a single-family, detached, owner-occupied primary residence; a loan-to-value ratio of less than 80% for conventional loans; a minimum FICO score of 740; and a loan amount of $375,000 for conforming loans, unless otherwise specified."
                ),
                React.createElement(
                    "p",
                    null,
                    "* Rates may be higher for loan amounts under $375,000."
                ),
                React.createElement(
                    "p",
                    null,
                    "* Rates assume that borrower will escrow property tax and insurance."
                ),
                React.createElement(
                    "p",
                    null,
                    "* Subject to underwriter approval; not all applicants will qualify."
                ),
                React.createElement(
                    "p",
                    null,
                    "* Assumes - 30 Day Rate Lock."
                ),
                React.createElement(
                    "p",
                    null,
                    "* Assumes - 1% Discount Cost."
                ),
                React.createElement(
                    "p",
                    null,
                    "* Rates based on Texas property."
                )
            )
        )
    );
}

export default Rates;